import _ from "lodash";
// Internal
import { getRating } from "../ratingPrimitives";

export const getMypCriteriaFinalScoreCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
}) => {
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
  };
};
